import { getCustomerQuery } from '@framework/utils/queries/get-customer-query'
import { getCustomerOrdersQuery } from '@framework/utils/queries/get-orders-query'
import { getCustomerOrderQuery } from '@framework/utils/queries/get-order-query'
import { getProductsRegisterRetailQuery } from '@framework/utils/queries/get-products-register-retail-query'
import {
  getProductsByIDQuery,
  getProductByIDQuery,
  getProductByHandleQuery,
  createCustomerAccessTokenMutation
} from '@framework/utils/queries'
import { GraphQLClient } from 'graphql-request'
import { composeGidFactory } from '@shopify/admin-graphql-api-utilities'

const composeGid = composeGidFactory('shopify')

const graphQLClient = new GraphQLClient(
  `https://${process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_DOMAIN}/api/${process.env.NEXT_PUBLIC_SHOPIFY_GRAPHQL_API_VERSION}/graphql.json`,
  {
    headers: {
      'X-Shopify-Storefront-Access-Token': process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN as string
    }
  }
)

export function getCustomerEmailFromAccessToken(customerAccessToken: string) {
  return graphQLClient.request(getCustomerQuery, {
    customerAccessToken
  })
}

export function getProductsWithIDs(ids: string[]) {
  return graphQLClient.request(getProductsByIDQuery, {
    ids: ids.map((id: string) => composeGid('Product', id))
  })
}

export function getProductWithID(id: string) {
  return graphQLClient.request(getProductByIDQuery, {
    id: composeGid('Product', id)
  })
}

export function getShopifyProductWithHandle(handle: string) {
  return graphQLClient.request(getProductByHandleQuery, {
    handle: handle
  })
}

export async function getProductsForRegisterRetail() {
  return graphQLClient.request(getProductsRegisterRetailQuery)
}

export function getCustomerOrders(customerAccessToken: string) {
  return graphQLClient.request(getCustomerOrdersQuery, {
    customerAccessToken
  })
}

export function getCustomerOrder(customerAccessToken: string, id: string) {
  return graphQLClient.request(getCustomerOrderQuery, {
    customerAccessToken,
    query: `id:${id}`
  })
}

export function getCustomerOrderChilds(customerAccessToken: string, id: string) {
  return graphQLClient.request(getCustomerOrderQuery, {
    customerAccessToken,
    query: `initial_order_name:${id}`
  })
}

export function createCustomerAccessToken(email: string, password: string) {
  return graphQLClient.request(createCustomerAccessTokenMutation, {
    input: {
      email,
      password
    }
  })
}
